export const OFFICE_HOURS = 'OFFICE_HOURS';